import React, { useEffect, useState } from "react";
import NavBar from "@/components/NavBar";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmt } from "@/lib/format";

const STATUS_LABEL = { pending: "en attente", accepted: "acceptée", in_progress: "en cours", completed: "terminée", cancelled: "annulée" };

export default function History() {
  const { user } = useAuth();
  const [rides, setRides] = useState([]);

  useEffect(() => {
    (async () => { try { const { data } = await api.get("/rides/history"); setRides(data || []); } catch {} })();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <NavBar />
      <main className="p-6 md:p-10 max-w-5xl mx-auto">
        <p className="font-mono-eyebrow">// Mes trajets</p>
        <h1 className="font-display text-4xl mt-1">HISTORIQUE</h1>

        {rides.length === 0 ? (
          <div className="mt-6 brut-card p-6">
            <p className="font-display text-2xl">AUCUN TRAJET</p>
            <p className="mt-2 text-[#52525B]">Vos courses terminées apparaîtront ici.</p>
          </div>
        ) : (
          <div className="mt-6 space-y-3" data-testid="history-list">
            {rides.map(r => (
              <div key={r.ride_id} className="brut-card p-4" data-testid={`history-item-${r.ride_id}`}>
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-mono-eyebrow">{new Date(r.created_at).toLocaleString("fr-CH")}</p>
                    <p className="font-display text-lg mt-1">{r.pickup?.address?.slice(0, 60)} → {r.destination?.address?.slice(0, 60)}</p>
                  </div>
                  <div className="text-right">
                    <p className="font-display text-2xl">{fmt(r.fare)}</p>
                    <span className="brut-badge">{STATUS_LABEL[r.status] || r.status}</span>
                  </div>
                </div>
                <div className="mt-2 text-xs text-[#52525B]">
                  {user?.role === "passenger" ? `Chauffeur : ${r.driver_name || "—"}` : `Passager : ${r.passenger_name}`}
                  {" · "}{r.vehicle_type?.toUpperCase()} · {r.distance_km}km
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
